<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          <div class="dialog-header-content">
            <div class="dialog-title-wrapper">
              <div class="dialog-icon">
                <icon name="global-icon" />
              </div>

              <div class="dialog-text">
                <div class="dialog-title">IPCR Targets Approvals</div>

                <div class="dialog-subtitle">
                  Manage and monitor monthly accomplishments, outputs, and
                  performance results.
                </div>
              </div>
            </div>

            <v-btn icon class="close-btn" @click="closeD()">
              <icon name="circle-close" />
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-col cols="12" v-if="isSubmitted">
            <v-stepper alt-labels class="elevation-0">
              <v-stepper-header>
                <v-stepper-step
                  step="1"
                  class="pa-5"
                  :complete="assessed_by_status == 2 ? true : false"
                  :rules="[() => assessed_by_status != 3]"
                  color="#6DB249"
                >
                  <div style="width: 200px" class="text-center">
                    {{ assessed_by }}<br />
                    <small>Assessed By</small>
                  </div>
                </v-stepper-step>
              </v-stepper-header>
            </v-stepper>
          </v-col>
          <v-col cols="8" class="flex-items mt-2">
            <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
              <v-tab
                v-for="tab in tabList"
                :key="tab.id"
                @click="changeTab(tab)"
                >{{ tab.name }}</v-tab
              >
            </v-tabs>
          </v-col>
          <v-spacer></v-spacer>

          <v-card class="dt-container" elevation="0" outlined>
            <v-data-table
              :headers="tab != 3 ? headers : support_headers"
              :items="dataItem"
              :items-per-page="10"
            >
              <template v-slot:[`item.efficiency`]="{ item }">
                {{
                  item.efficiency_type == "percentage"
                    ? item.efficiency + "%"
                    : item.efficiency
                }}
              </template>
              <template v-slot:[`item.success_indicator`]="{ item }">
                <div class="text-justify">
                  {{ item.success_indicator }}
                </div>
              </template>
              <template v-slot:[`item.eqt`]="{ item }">
                <div class="text-center">
                  <div class="d-flex align-center justify-center">
                    <div class="text-caption">E -</div>
                    <div class="align-self-center">
                      <v-icon color="#519043" v-if="item.eff_is_rated"
                        >mdi-check</v-icon
                      >
                      <v-chip x-small class="pa-1" v-if="!item.eff_is_rated"
                        >NR</v-chip
                      >
                    </div>
                  </div>
                  <div class="d-flex align-center justify-center">
                    <div class="text-caption">Q -</div>
                    <div class="align-self-center">
                      <v-icon color="#519043" v-if="item.qly_is_rated"
                        >mdi-check</v-icon
                      >
                      <v-chip x-small class="pa-1" v-if="!item.qly_is_rated"
                        >NR</v-chip
                      >
                    </div>
                  </div>
                  <div class="d-flex align-center justify-center">
                    <div class="text-caption">T -</div>
                    <div class="align-self-center">
                      <v-icon color="#519043" v-if="item.timeliness_is_rated"
                        >mdi-check</v-icon
                      >
                      <v-chip
                        x-small
                        class="pa-1"
                        v-if="!item.timeliness_is_rated"
                        >NR</v-chip
                      >
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:[`item.actions`]="{ item }" v-if="tab != 3">
                <v-btn
                  v-if="item.pendingRemarks.length > 0"
                  class="global-btn-save my-1"
                  @click="viewItem(item)"
                >
                  view remarks
                </v-btn>
                <v-btn class="global-btn-save my-1" @click="pendingItem(item)">
                  Add Pending Remarks
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end" v-if="approval == 1">
          <v-card-text class="pa-1 mt-8 d-flex justify-end">
            <v-spacer></v-spacer>

            <!-- <v-btn color="red" outlined @click="pending()">
            pending
          </v-btn> -->

            <v-btn
              class="btn-pending mr-3"
              v-if="!toPending"
              outlined
              @click="setToPending()"
            >
              Pending
            </v-btn>

            <v-btn class="btn-save" v-if="!toPending" @click="approve()">
              Approve
            </v-btn>

            <v-btn
              class="btn-pending mr-3"
              :disabled="confirmLoading"
              v-if="toPending"
              outlined
              @click="cancelPending()"
              style="min-width: 140px"
            >
              Cancel Pending
            </v-btn>
            <v-btn
              v-if="toPending"
              class="btn-save"
              :disabled="confirmLoading"
              :loading="confirmLoading"
              @click="confirmPending()"
              style="min-width: 140px"
            >
              Confirm Pending
            </v-btn>
          </v-card-text>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmSubmitDialog"
      persistent
      max-width="420"
      content-class="delete-dialog-content"
    >
      <v-card class="delete-dialog">
        <div class="delete-content">
          <div class="submit-icon">
            <icon name="circle-check" />
          </div>

          <div class="delete-title">Confirm Pending?</div>

          <div class="delete-description">
            Are you sure you want to submit this
            <strong>IPCR Targets for Approval</strong>?
          </div>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn
            text
            color="grey darken-1"
            class="btn-cancel"
            :disabled="confirmBtnLoading"
            @click="cancelConfirm()"
          >
            Cancel
          </v-btn>

          <v-spacer />

          <v-btn
            color="#147452"
            depressed
            :loading="confirmBtnLoading"
            :disabled="confirmBtnLoading"
            class="btn-save"
            @click="confirmSubmit()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- remarks dialog -->
    <v-dialog
      v-model="addRemarksDialog"
      persistent
      max-width="600"
      content-class="rounded-dialog"
    >
      <v-card color="white">
        <v-form ref="RemarksFormref" @submit.prevent>
          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="circle-add" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">
                    {{
                      approvalAction == "APPROVE"
                        ? "Add Comments and Recommendations"
                        : "Add Remarks"
                    }}
                  </div>

                  <div class="dialog-subtitle">
                    Add Comments and Recommendations for Development Purposes
                  </div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="close()">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text style="max-height: 150px" class="my-4">
            <v-row>
              <v-col cols="12">
                <v-textarea
                  label="Type your comments and recommendation here ..."
                  v-model="remarksMsg"
                  outlined
                  dense
                  :rules="[formRules.required]"
                  class="rounded-lg"
                  color="#6DB249"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>
            <v-btn class="btn-cancel" outlined @click="closeRemarksDialog()">
              Close
            </v-btn>
            <v-btn
              v-if="approvalAction == 'APPROVE'"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
              class="btn-save"
              @click="saveApprovalRemarks()"
            >
              Save
            </v-btn>
            <v-btn
              v-if="approvalAction == 'PENDING'"
              color="green"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
              class="white--text"
              @click="savePendingRemarks()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <RemarksDialog
      :data="itemToPending"
      v-on:saveRemarks="saveRemarks"
      v-on:closeRemarks="closeRemarks"
      :type="type"
      :moduleFrom="'IPCR TARGET APPROVAL'"
    />

    <ViewRemarksTimelineDialog
      :data="list"
      v-on:closeRemarksTimeline="closeRemarksTimeline"
    />
    <WarningDialog :msg="cancelMsg" v-on:yes="yes" v-on:no="no" />

    <!-- <MPORDialog :data="mporData" :action="action" /> -->
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="fadeAwayMessage.timeout"
    ></fade-away-message-component>
  </div>
</template>

<script>
import RemarksDialog from "./RemarksDialog.vue";
import ViewRemarksTimelineDialog from "./ViewRemarksTimelineDialog.vue";
import WarningDialog from "./WarningDialog.vue";
import icon from "@/assets/icon.vue";
export default {
  components: {
    RemarksDialog,
    ViewRemarksTimelineDialog,
    WarningDialog,
    icon,
  },
  props: {
    data: null,
    approval: null,
  },
  data() {
    return {
      remarksData: [],
      confirmBtnLoading: false,
      confirmLoading: false,
      confirmSubmitDialog: false,
      addPendingRemarksDialog: false,
      pendingRemarksMsg: null,
      itemToPending: null,
      confirmDialog: false,
      user_detailID: null,
      approvalAction: null,
      assesed_by_status: null,
      remarksMsg: null,
      addRemarksDialog: false,
      itemToDelete: null,
      options: {},
      action: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
        timeout: 1500,
      },
      mporData: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Support Functions" },
      ],
      target_rating: null,
      ipcrData: null,
      ipcrSupData: null,
      isSubmitted: null,
      isSubmitLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      id: null,
      dataItem: [],
      isButtonLoading: false,
      headers: [
        {
          text: "Major Final Output",
          value: "mfo",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          valign: "start",
          sortable: false,
        },
      ],
      support_headers: [
        {
          text: "Type",
          value: "type",

          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",

          valign: "center",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accom",
          align: "start",

          valign: "center",
          sortable: false,
        },
      ],
      toPending: false,
      pendingList: [],
      type: null,
      list: [],
      cancelMsg: null,
      submitAction: null,
    };
  },
  computed: {},
  watch: {
    data: {
      handler(data) {
        console.log("ss", data);
        this.toPending = false;
        this.itemToPending = null;
        this.setHeaders();
        this.pendingList = [];
        this.dialog = true;
        this.user_detailID = data.user_detailID;
        this.activeTab = { id: 1, name: "Core Functions" };
        this.target_rating = data;
        this.tab = 1;
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },

  methods: {
    initialize() {
      this.loading = true;

      if (this.tab != 3) {
        this.axiosCall(
          "/ipcr-target/getMyIPCRTarget/" +
            this.target_rating.ipcr_ID +
            "/" +
            this.tab,
          "GET",
        ).then((res) => {
          if (res) {
            console.log(res.data);
            this.isSubmitted = res.data.target_rating.isSubmitted;
            this.dataItem = res.data.targets;
            this.loading = false;
          }
        });
      } else {
        this.axiosCall(
          "/ipcr-target/getEmployeeIPCRSupportTarget/" +
            this.target_rating.ipcr_ID +
            "/" +
            this.user_detailID,
          "GET",
        ).then((res) => {
          if (res) {
            if (res.data.status == 200) {
              console.log("hehehe", res.data.targets);
              this.dataItem = res.data.targets;
            } else {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }

            this.loading = false;
          }
        });
      }

      //load signatory
      this.axiosCall(
        "/ipcr/getIPCRApproverNames/" + this.target_rating.ipcr_ID + "/TARGET",
        "GET",
      ).then((res) => {
        if (res) {
          this.assessed_by = this.toTitleCase(res.data.assessed_by_name);
          this.assessed_by_status = res.data.assesed_by_status;
          // this.final_rating_by = this.toTitleCase(
          //   res.data.final_rating_by_name
          // );
          // this.final_rating_by_status = res.data.final_rating_by_status;
        }
      });
    },

    closeRemarksDialog() {
      this.confirmBtnLoading = false;
      this.addRemarksDialog = false;
    },

    closePendingRemarksDialog() {
      this.addPendingRemarksDialog = false;
    },

    yes() {
      if (this.submitAction == "cancel pending") {
        this.removePendingRemarks();
      }
      if (this.submitAction == "confirm pending") {
        this.submitForPending();
      }
      if (this.submitAction == "approve") {
        this.showApprovalRemarks();
      }
    },
    no() {
      this.submitAction = null;
      this.cancelMsg = null;
    },

    approve() {
      this.approvalAction = "APPROVE";
      this.cancelMsg =
        "Are you sure you want to APPROVE this? Please note that this action is irreversible.";
      this.submitAction = "approve";
    },

    showApprovalRemarks() {
      this.submitAction = null;
      this.cancelMsg = null;
      this.addRemarksDialog = true;
    },

    // approve() {
    //   this.approvalAction = "APPROVE";
    //   this.confirmSubmitDialog = true;
    // },

    pending() {
      this.approvalAction = "PENDING";
      this.confirmSubmitDialog = true;
    },

    setToPending() {
      this.toPending = true;
      this.setHeaders();
    },

    setHeaders() {
      let headers = [
        {
          text: "Major Final Output",
          value: "mfo",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          valign: "start",
          sortable: false,
        },
      ];
      let headersWAction = [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Action",
          value: "actions",
          width: 200,
          align: "center",
          sortable: false,
        },
      ];
      let support_headers = [
        {
          text: "Type",
          value: "type",

          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "suc_ind",
          align: "start",

          valign: "center",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accom",
          align: "start",

          valign: "center",
          sortable: false,
        },
      ];
      // let support_headers_WAction = [
      //   {
      //     text: "Type",
      //     value: "type",

      //     align: "start",
      //     valign: "start",
      //     sortable: false,
      //   },
      //   {
      //     text: "Success Indicator",
      //     value: "success_indicator",
      //     align: "start",

      //     valign: "center",
      //     sortable: false,
      //   },
      //   {
      //     text: "Actual Accomplishment",
      //     value: "actual_accom",
      //     align: "start",

      //     valign: "center",
      //     sortable: false,
      //   },
      //   {
      //     text: "Action",
      //     value: "actions",
      //     align: "center",
      //     width: 200,
      //     sortable: false,
      //   },
      // ];

      this.headers = this.toPending ? headersWAction : headers;
      this.support_headers = support_headers;
      // ? support_headers
      // : support_headers;
    },

    closeD() {
      if (this.pendingList.length > 0) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "warning";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.timeout = 5000;
        this.fadeAwayMessage.message =
          "You have added pending remarks! Please click the CANCEL PENDING button to cancel the pending process.";
      } else {
        this.eventHub.$emit("closeViewIPCRTargetApprovalDialog", false);
        this.addRemarksDialog = false;
        this.confirmSubmitDialog = false;
        this.confirmBtnLoading = false;
        this.isSubmitLoading = false;
        this.dialog = false;
      }
    },
    edit(item) {
      if (this.tab != 3) {
        this.ipcrData = item;
        this.action = "Update";
      } else {
        this.ipcrSupData = item;
        this.action = "Update";
      }
    },
    submitTarget() {
      this.confirmSubmitDialog = true;
    },

    confirmSubmit() {
      this.confirmBtnLoading = true;
      this.addRemarksDialog = true;
    },

    saveRemarks(data) {
      this.pendingList.push(data);
      this.initialize();
      console.log("SAVE REMARKS", data);
    },
    closeRemarks(data) {
      this.itemToDelete = data;
    },

    closeRemarksTimeline() {
      this.list = [];
    },

    pendingItem(item) {
      this.type =
        this.tab == 1
          ? "Core Function"
          : this.tab == 2
          ? "Strategic Priority"
          : this.tab == 3
          ? "Support Function"
          : "";
      setTimeout(() => {
        this.itemToPending = item;
      }, 100);
      this.itemToPending = null;
      // console.log("PENDING", item);
    },

    viewItem(item) {
      console.log(item.pendingRemarks);

      this.list = [];
      setTimeout(() => {
        this.list = item.pendingRemarks;
      }, 100);
    },

    saveApprovalRemarks() {
      if (this.$refs.RemarksFormref.validate()) {
        this.confirmSubmitDialog = false;
        this.confirmBtnLoading = true;
        this.isSubmitLoading = true;
        let data = {
          remarks: this.remarksMsg,
          targetRatingID: this.target_rating.id,
        };
        this.axiosCall("/ipcr-target/approveTargets", "POST", data).then(
          (res) => {
            if (res.data.status == 200) {
              this.cancelMsg = null;
              this.confirmBtnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.closeD();
            } else if (res.data.status == 400) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          },
        );
      }
    },

    submitForPending() {
      let data = {
        remarks: null,
        targetRatingID: this.target_rating.id,
      };
      this.axiosCall("/ipcr-target/pendingTargets", "POST", data).then(
        (res) => {
          if (res.data.status == 200) {
            this.cancelMsg = null;
            this.confirmLoading = false;
            this.toPending = false;
            this.pendingList = [];
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else if (res.data.status == 400) {
            this.cancelMsg = null;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        },
      );
    },

    removePendingRemarks() {
      let data = {
        list: JSON.stringify(this.pendingList),
      };
      this.axiosCall("/remarks/remove-pending-remarks", "POST", data).then(
        (res) => {
          if (res.data.status == 200) {
            this.submitAction = null;
            this.cancelMsg = null;
            this.toPending = false;
            this.pendingList = [];
            this.setHeaders();
            this.initialize();
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = "Pending Cancelled!";

            // this.closeD();
          } else if (res.data.status == 400) {
            this.submitAction = null;
            this.cancelMsg = null;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        },
      );
    },

    confirmPending() {
      this.submitAction = "confirm pending";
      this.cancelMsg =
        "Are you sure you want to PENDING this? Please note that this action is irreversible.";
    },

    cancelPending() {
      this.submitAction = "cancel pending";
      if (this.pendingList.length > 0) {
        this.cancelMsg =
          "You have added pending remarks! Are you sure you want to CANCEL the Pending? Added remarks will not be saved.";
      } else {
        this.removePendingRemarks();
      }
    },

    // savePendingRemarks() {
    //   this.confirmSubmitDialog = false;
    //   this.confirmBtnLoading = true;
    //   // this.isSubmitLoading = true;
    //   if (this.$refs.RemarksFormref.validate()) {
    //     let data = {
    //       remarks: this.remarksMsg,
    //       targetRatingID: this.target_rating.id,
    //     };
    //     this.axiosCall("/ipcr-target/pendingTargets", "POST", data).then(
    //       (res) => {
    //         if (res.data.status == 200) {
    //           this.confirmBtnLoading = false;
    //           this.fadeAwayMessage.show = true;
    //           this.fadeAwayMessage.type = "success";
    //           this.fadeAwayMessage.header = "System Message";
    //           this.fadeAwayMessage.message = res.data.msg;
    //           this.closeD();
    //         } else if (res.data.status == 400) {
    //           this.fadeAwayMessage.show = true;
    //           this.fadeAwayMessage.type = "error";
    //           this.fadeAwayMessage.header = "System Message";
    //           this.fadeAwayMessage.message = res.data.msg;
    //         }
    //       }
    //     );
    //   }
    // },

    cancelConfirm() {
      this.approvalAction = null;
      this.confirmSubmitDialog = false;
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },

    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },
  },
};
</script>
<style scoped></style>
